
<app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent" [isLogoutVisible]="isLogoutVisible"> </app-brand-header>

<div class="link-wrapper">
  <a href='/dsb-ocr' >Back to Available Funds</a>
</div>

<main class="dsb-cards-container">
  <div *ngFor="let fundingAccount of fundingAccounts">
    <app-funding-account [fundingAccount]="fundingAccount" (deleteFundingAccount)="deleteFundingAccountHandler($event)"
      [varTest]="varTest"
      [dsbOccurrenceUuid]="dsbOccurrenceUuid">
    </app-funding-account>
  </div>
</main>

<div class="funding-accounts-actions">

  <div class="button-wrapper">
    <button (click)="onAddAch()">{{achButtonLiteral}}</button>
  </div>

  <div class="button-wrapper">
    <button (click)="onAddCard()">{{cardButtonLiteral}}</button>
  </div>

<!-- 
    <button type="button" class="dsb-btn" (click)="onAddAch()">
      Add ACH
    </button>
    <button type="button" class="dsb-btn" (click)="onAddCard()">
      Add Card
    </button>
     -->


  </div>

  <button (click)="setVarTest()"> Set varTest </button>

  {{varTest()}}

<div class="funding-accounts-footer">
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    {{dsbMessage}}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-lable="Close"></button>
  </div>
</div>
